import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../constants/qa'
import { setStorageItem } from '../../../../utils/storage'
import { Checkbox, CHECKBOX_SIZE } from '../../../Checkbox'
import { ConfirmationModal } from '../../../Confirmation'
import { EMAIL_COPY_TO_ENTITY_MODAL_IS_PRIVATE_CONFIRMATION_AGAIN_DISABLED } from '../EmailCopyToEntityModal.constants'

import * as styles from './EmailCopyToEntityPrivateConfirmationModal.module.css'

function EmailCopyToEntityPrivateConfirmationModal({ onCancel, onSubmit }) {
  const { t } = useTranslation()

  const [isShowAgainDisabled, setShowAgainDisabled] = useState(false)

  function handleSubmit() {
    if (isShowAgainDisabled) {
      setStorageItem(
        EMAIL_COPY_TO_ENTITY_MODAL_IS_PRIVATE_CONFIRMATION_AGAIN_DISABLED,
        isShowAgainDisabled
      )
    }

    onSubmit()
  }

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitText: t('Email.CopyToEntityConfirmBtnKey'),
      }}
      description={
        <>
          <span>{t('Email.CopyToEntityConfirmModalTextKey')}</span>
          <span>{t('Email.CopyToEntityConfirmModalTextQuestionKey')}</span>
        </>
      }
      descriptionProps={{ className: styles.description }}
      qaName={QA_NAME_CONFIRMATION}
      onCancel={onCancel}
      onSubmit={handleSubmit}
    >
      <Checkbox
        checked={isShowAgainDisabled}
        className={styles.checkbox}
        label={t('Email.CopyToEntityConfirmModalCheckboxTitleKey')}
        size={CHECKBOX_SIZE.small}
        onChange={setShowAgainDisabled}
      />
    </ConfirmationModal>
  )
}

export default EmailCopyToEntityPrivateConfirmationModal
